export const useCommonValidation = {
  // Проверка email
  validateEmail(email: string): string | null {
    const emailValue = String(email).trim()

    if (!emailValue) {
      return 'Электронная почта должна быть заполнена'
    }

    // Простая проверка формата email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(emailValue)) {
      return 'Некорректный формат электронной почты'
    }

    return null
  },

  // Проверка phone
  validatePhone(phone: string): string | null {
    const phoneValue = String(phone).trim()

    if (!phoneValue) {
      return null // Phone не обязательное поле
    }

    // Проверка: может начинаться с +, код в скобках (необязательно), содержит только цифры и пробелы
    // Форматы: +7 123 456 78 90, +7 (123) 456 78 90, 8 (123) 456-78-90
    const phoneRegex = /^\+?\d(?:\s*\(\d{3}\)\s*|\s*\d{3}\s*)\d{3}[\s-]?\d{2}[\s-]?\d{2}$/
    if (!phoneRegex.test(phoneValue)) {
      return 'Некорректный формат телефона. Используйте формат: +7 123 456 78 90 или +7 (123) 456 78 90'
    }

    // Удаляем +, (), - и пробелы, проверяем количество цифр
    const digitsOnly = phoneValue.replace(/[+()\s-]/g, '')
    if (digitsOnly.length < 10 || digitsOnly.length > 15) {
      return 'Телефон должен содержать от 10 до 15 цифр'
    }

    return null
  }
}
